/**
 * @generated SignedSource<<eb54e0c48223fea431eda2b59d590201>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Row844BadPattern">;
  readonly " $fragmentType": "Row";
};
export type Row$key = {
  readonly " $data"?: Row$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Row",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Row844BadPattern"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "2118024fb0d0fd30d7cf8508c440eb96";

export default node;
